import Link from 'next/link';
import React from 'react';
import { icons } from '@/Icons';

type MainLogoType = 'desktop' | 'mobile' | null;

export interface MainLogoProps {
	additionalText?: boolean;
	className?: string;
	logoType?: MainLogoType;
}

const MainLogo = ({
	additionalText,
	className = '',
	logoType = null,
}: MainLogoProps) => {
	return (
		<Link
			href="/"
			className={`flex items-center gap-1.5  font-bold   group relative w-full  ${className}    `}
			aria-label="Home"
		>
			{logoType === 'desktop' ? (
				<DesktopLogo logoType={logoType} />
			) : logoType === 'mobile' ? (
				<MobileLogo logoType={logoType} />
			) : (
				<>
					<DesktopLogo logoType={logoType} />
					<MobileLogo logoType={logoType} />
				</>
			)}

			{/* {additionalText ? (
				<p className="items-center hidden md:flex font-bold whitespace-nowrap mx-2">
					The Real Estate Casino
				</p>
			) : null} */}
		</Link>
	);
};

export default MainLogo;

export const DesktopLogo = ({ logoType }: { logoType: MainLogoType }) => {
	return (
		<icons.mainlogoletters
			className={`${logoType ? '' : 'hidden md:flex'} mx-auto md:mx-0 h-[26px] w-[141px] `}
		/>
	);
};

const MobileLogo = ({ logoType }: { logoType: MainLogoType }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 32 33"
			fill="none"
			className={`${logoType ? '' : 'md:hidden'} h-[32px] w-fit `}
		>
			<path
				d="M29.8889 8.35185C28.4815 5.90741 26.5556 4.01852 24.1481 2.61111C21.7037 1.2037 19 0.5 16 0.5C13 0.5 10.2963 1.2037 7.85185 2.61111C5.40741 4.01852 3.51852 5.94444 2.11111 8.35185C0.703704 10.7963 0 13.5 0 16.5C0 19.5 0.703704 22.2037 2.11111 24.6481C3.51852 27.0926 5.44444 28.9815 7.85185 30.3889C10.2963 31.7963 13 32.5 16 32.5C19 32.5 21.7037 31.7963 24.1481 30.3889C26.5926 28.9815 28.4815 27.0556 29.8889 24.6481C31.2963 22.2407 32 19.5 32 16.5C32 13.5 31.2963 10.7963 29.8889 8.35185ZM25.2963 22.2037C24.3704 23.8704 23.1111 25.1296 21.4815 26.0556C19.8519 26.9444 18.037 27.4259 16 27.4259C13.963 27.4259 12.1481 26.9815 10.5185 26.0556C8.88889 25.1296 7.62963 23.8704 6.7037 22.2037C5.77778 20.537 5.33333 18.6481 5.33333 16.5C5.33333 14.3519 5.77778 12.463 6.7037 10.7963C7.62963 9.12963 8.88889 7.87037 10.5185 6.94444C12.1481 6.01852 13.963 5.57407 16 5.57407C18.037 5.57407 19.8519 6.01852 21.4815 6.94444C23.1111 7.83333 24.3704 9.12963 25.2963 10.7963C26.2222 12.463 26.6667 14.3519 26.6667 16.5C26.6667 18.6481 26.2222 20.537 25.2963 22.2037Z"
				fill="white"
			/>
			<path
				d="M15.8089 23.9517C14.3791 21.1136 12.4217 18.6742 10.1478 16.8966L9.85547 16.6676L10.1478 16.4386C12.4227 14.661 14.3801 12.2216 15.8089 9.3835L16.0712 8.86328L16.3326 9.3835C17.7624 12.2206 19.7198 14.66 21.9937 16.4386L22.286 16.6676L21.9937 16.8966C19.7198 18.6752 17.7624 21.1146 16.3326 23.9517C16.2865 24.0431 16.0712 24.258 16.0712 24.258C16.0712 24.258 15.855 24.0431 15.8089 23.9517Z"
				fill="currentColor"
				// className="group-hover:fill-electric-sky duration-200 spin ease-in-out group-hover:drop-shadow-[0_0_1px_#6680F1]"
			/>
		</svg>
	);
};
